import BasicLayout from '@/layouts/Basic';

export default [
    {
        path: '/user/:userid/assets',
        name: 'assetsLibraryPictrue',
        component: BasicLayout,
        meta: {
            onlyV1: true
        },
        children: [
            {
                path: 'picture',
                name: 'assetsLibraryPictrue',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true
                },
                component: () => import('@/component/AssetsLibrary/Picture')
            },
            {
                path: 'video',
                name: 'assetsLibraryVideo',
                meta: {
                    // authorizedRole: 'digital_human_list'
                },
                component: () => import('@/component/AssetsLibrary/Video')
            }
        ]
    }
];
